import axios from "@/plugins/axios";

class PremiacoesService {
  async getAll() {
    const res = await axios.get("/premiacoes");
    return res.data;
  }
  
  async create(data) {
    const res = await axios.post("/premiacoes", data);
    return res.data;
  }
  
  async update(id, data) {
    // Backend usa PATCH para atualizações parciais
    const res = await axios.patch(`/premiacoes/${id}`, data);
    return res.data;
  }
  
  async delete(id) {
    const res = await axios.delete(`/premiacoes/${id}`);
    return res.data;
  }
}
export default new PremiacoesService();